<div class="state_toggler__wrapper">
    <div class="slider" #slider [ngStyle]="{'left': option.selected.id*40+'px','background-color':(option.selected.color)?option.selected.color:'#fff'}"></div>
    <div class="states">
        <label *ngFor="let item of option.data" for="{{item.id}}_state" (click)="changeState(item)">
            <input type="radio" id="{{item.id}}_state" name="{{option.group}}">
            <i *ngIf="item.icon" class="{{item.icon}}" [ngStyle]="{'color': (option.selected.id == item.id)?(item.textColor)?item.textColor:'#333':'#333'}"></i>
        </label>
    </div>
</div>
